// Analytics constants
export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
export const CATEGORY = 'Wallet';
export const ACTION_NAME = 'Live Balance Requested - ';
